import styled from "styled-components";
import { COLORS } from "../../constants/colors";

export const HeaderContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 20px;
    height: 60px;
    background-color: #fff;
    border-bottom: 1px solid #e8e8e8;
`;

export const LogoContainer = styled.div`
    display: flex;
    justify-content: left;
    align-items: left;
    flex: 1;
`;

export const LinkContainer = styled.div`
    display: flex;
    align-items: center;
    margin-left: auto;
    a {
        color: ${COLORS.$blue};
        margin-right: 10px;
    }
`;

export const CopyButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    font-size: 16px;
    color: ${COLORS.$blue};

    &:hover {
        color: ${COLORS.$darkBlue};
    }
`;
export const Logo = styled.img`
    height: 20px;
`;